import { REDUX_DOMAIN_LIST_SECTION_KEY } from '../../../../redux/constants/key'
import WORKOUTS_DOMAIN from '../../../redux/constants/domain'
import { joinPathsStringUtil } from '../../../../../utils/string/get-joined-paths'

export default function getByPlanIdDomainListPathFromPlanIdWorkoutUtil ({
  planId,
  week
}) {
  return joinPathsStringUtil(
    WORKOUTS_DOMAIN,
    'byPlan',
    planId,
    `${REDUX_DOMAIN_LIST_SECTION_KEY.BY_WEEK}.${week}`
  )
}
